// extracted by css-extract-rspack-plugin
export default {"Box":"filter-counter-label-module__Box__R0nLf"};